/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

@Component({
	selector: "globalictcc-toggle",
	standalone: true,
	imports: [MatSlideToggleModule],
	templateUrl: "./toggle.component.html",
	styleUrl: "./toggle.component.scss"
})
export class ToggleComponent {
	@Input() public checked: boolean = false;
	@Input() public disabled: boolean = false;

	@Output() public handleToggleChange = new EventEmitter<boolean>();
}
